import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-send-reminder-letter-advt',
  templateUrl: './send-reminder-letter-advt.component.html',
  styleUrl: './send-reminder-letter-advt.component.scss'
})
export class SendReminderLetterAdvtComponent {

  currentDate: Date;
  getpendingreceipt: any;
  PendingReceiptAmt: number;
  PendingBalanceAmt: number;
  isEditMode: boolean = false;
  isSaving: boolean = false;

  // Add these new properties for address and advt_name
  advtName: string = '';
  advtAddress: string = '';

  // Dynamic letter body text
  letterBodyText = {
    template_name: 'send-reminder1',
    subject_line: '',
    greeting: '',
    paragraph1: '',
    paragraph2: '',
    paragraph3: '',
    details_heading: '',
    closing_text: ''
  };

  // Default text (fallback if API fails or no data)
  defaultLetterText = {
    template_name: 'send-reminder1',
    subject_line: 'विषय : मागील जाहिरात येणे बाकी सदंर्भात स्मरण पत्र .........',
    greeting: 'सस्नेह नमस्कार',
    paragraph1: 'सा.विवेक हे महाराष्ट्रातील सर्व महत्वाच्या घडामोडींचा आढावा घेणारे वैचारिक साप्ताहिक आहे. प्रसारमाध्यमातून सामाजिक परिवर्तनाचे राष्ट्रीय कार्य गेली 78 वर्षे अखंडीतपणे सुुरू आहे. हा प्रवास आपल्याकडून सा.विवेकला वेळोवेळी मिळत असलेल्या अर्थ पूर्ण सहकार्यामुळेच शक्य होत आहे. या करीता आपले मन:पूर्वक धन्यवाद !',
    paragraph2: 'आपण जाणताच की, कोणत्याही राजकीय अथवा ोठ्या औद्योगिक समूहाचे आर्थिक पाठबळ नसताना विवेक केवळ आपल्यासारख राष्ट्रभक्त हितचिंतकांच्या आश्वासक पाठिंब्यामुळेच सुरू आहे. याचा विवेक समूहाला सार्थ अभिमान आहे. मागील अंकात आपली, आपल्या आस्थापनाची जाहिरात प्रकाशित करण्यात आली होती.  मात्र ही दे रक्क कार्यालयात अद्याप जमा झालेली नाही.',
    paragraph3: 'अशा प्रकारची देय रक्कम कार्यालयात जमा न होणे हे प्रसारमाध्यम क्षेत्रात काम करणार्‍या विवेक सारख सामाजिक संस्थेला परवडणारे नसते, हे आपण जाणताच! आपली दे रक्कम आपल्या व्यग्र कामकाजामुळे राहून गेली असावी असे आम्हाला वाटते. तरी आपणास नम्र विनंती आहे की, ही देय रक्कम कार्यालयात लवकरात लवकर जमा करावी. धन्यवाद !',
    details_heading: 'येणे बाकी तपशील खालील प्रमाणे आहे.',
    closing_text: ''
  };

  constructor(
    private dialogRef: MatDialogRef<SendReminderLetterAdvtComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  reportType: any;
  startDate: any;
  endDate: any;
  repName: any;
  offRepName: any;
  issueDates: any;
  issueDates1: any;

  OutStandingIDTotal: number = 0;
  OutStandingIDNetAmtTotal: number = 0;
  OutStandingIDUnPaidTotal: number = 0;

  ngOnInit(): void {
    this.currentDate = new Date();
    
    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'] || this.data['advt_name'] || '';
    this.issueDates = this.data.issueDates;
    this.issueDates1 = this.data['issue_date'];

    // Load letter template from backend
    this.loadLetterTemplate();

    const req: any = {
      "rep_name": this.repName,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "advt_name": this.advtName,
      "issue_name": "",
      "issue_date": this.issueDates1
    }

    this.service.getpendingreceipt(req).subscribe((data: any) => {
      debugger
      this.getpendingreceipt = data as any;
      console.log("pending receipt", data)

      // Extract address from first record if available
      if (this.getpendingreceipt && this.getpendingreceipt.length > 0) {
        this.advtAddress = this.getpendingreceipt[0].address || 
                          this.getpendingreceipt[0].advt_address || '';
        // Update advtName if not already set
        if (!this.advtName && this.getpendingreceipt[0].advt_name) {
          this.advtName = this.getpendingreceipt[0].advt_name;
        }
      }

      // Reset totals
      this.PendingReceiptAmt = 0;
      this.PendingBalanceAmt = 0;

      // Calculate totals
      for (let data1 of this.getpendingreceipt) {
        this.PendingReceiptAmt += parseInt(data1.advt_amt) || 0;
        this.PendingBalanceAmt += parseInt(data1.remain_amt) || 0;
      }
      
      this.cdr.detectChanges();
    });
  }

  /**
   * Load letter template from backend
   */
  loadLetterTemplate(): void {
    this.service.getLetterTemplate('send-reminder1').subscribe(
      (response: any) => {
        console.log('Letter template response:', response);
        
        if (response && response.success && response.data) {
          const data = response.data;
          
          this.letterBodyText = {
            template_name: data.template_name || 'send-reminder1',
            subject_line: data.subject_line || this.defaultLetterText.subject_line,
            greeting: data.greeting || this.defaultLetterText.greeting,
            paragraph1: data.paragraph1 || this.defaultLetterText.paragraph1,
            paragraph2: data.paragraph2 || this.defaultLetterText.paragraph2,
            paragraph3: data.paragraph3 || this.defaultLetterText.paragraph3,
            details_heading: data.details_heading || this.defaultLetterText.details_heading,
            closing_text: data.closing_text || this.defaultLetterText.closing_text
          };
        } else {
          console.log('No template found, using default');
          this.letterBodyText = { ...this.defaultLetterText };
        }
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error loading letter template:', error);
        this.letterBodyText = { ...this.defaultLetterText };
        this.cdr.detectChanges();
      }
    );
  }

  /**
   * Toggle edit mode on/off
   */
  toggleEditMode(): void {
    this.isEditMode = !this.isEditMode;
    
    if (!this.isEditMode) {
      this.loadLetterTemplate();
    }
  }

  /**
   * Save letter template to backend
   */
  saveLetterTemplate(): void {
    if (!this.letterBodyText.template_name) {
      alert('टेम्पलेट नाव आवश्यक आहे!');
      return;
    }

    this.isSaving = true;
    
    this.service.saveLetterTemplate(this.letterBodyText).subscribe(
      (response: any) => {
        console.log('Letter template saved successfully', response);
        this.isSaving = false;
        
        if (response && response.success) {
          alert('पत्र टेम्पलेट यशस्वीरित्या जतन केले! (Template saved successfully!)');
          this.isEditMode = false;
          this.cdr.detectChanges();
        } else {
          alert('त्रुटी: ' + (response.message || 'टेम्पलेट जतन करताना त्रुटी'));
        }
      },
      (error) => {
        console.error('Error saving letter template:', error);
        this.isSaving = false;
        alert('पत्र टेम्पलेट जतन करतानाची त्रुटी! (Error saving template!)');
      }
    );
  }

  /**
   * Reset to default template
   */
  resetToDefault(): void {
    if (confirm('तुम्हाला खरोखर डिफॉल्ट टेम्पलेट रीसेट करायचे आहे का? (Do you want to reset to default template?)')) {
      this.letterBodyText = { ...this.defaultLetterText };
      this.saveLetterTemplate();
    }
  }

  /**
   * Update specific field
   */
  updateLetterField(field: string, value: string): void {
    if (this.letterBodyText.hasOwnProperty(field)) {
      this.letterBodyText[field] = value;
    }
  }

  /**
   * Export to Excel
   */
  exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);
    
    let element = document.getElementById('print-section');
    console.log('Element found:', element);
    
    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }
    
    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);
      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      
      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

  show = false

  printPage() {
    this.show = true;
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
             @page {
  size: A4 portrait;
  margin: 5mm;
}
              .reminder-container {
    max-width: 210mm;
    margin: 0 auto;
    padding: 20px;
    border: 2px solid #000;
    background: #fff;
    font-family: 'Noto Sans Devanagari', Arial, sans-serif;
    color: #000 !important;
}

/* Header Section */
.header-section {
    padding-bottom: 15px;
    color: #000 !important;
}

.header-content {
    color: #000 !important;
}

.header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
}

.organization-info {
    flex: 1;
    text-align: right;
    line-height: 1.6;
    margin-right: 55px;
}

.organization-name {
    font-size: 20px;
    font-weight: bold;
    margin: 0 0 5px 0;
    color: #000;
    text-align: right;
    margin-right: 3px;
}

.registration-number {
    font-size: 13px;
    color: #000 !important;
    margin-right: 55px;
    text-align: right;
    margin: 0 0 5px 0;
}

.header-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    margin-left: 20px;
}

.header-logo img {
    margin-right: 50px;
    max-width: 190px;
    margin-top: 12px;
}

.header-divider {
    margin: 10px 0;
    border: none;
    border-top: 1px solid #333;
}

.office-details-single {
    font-size: 13px;
    line-height: 1.6;
    color: #000 !important;
    text-align: left;
}

.office-label {
    font-weight: bold;
    color: #000 !important;
}

.contact-label {
    font-weight: bold;
    color: #000 !important;
    margin-left: 188px;
}

/* Recipient Section */
.recipient-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 20px 0;
}

.recipient-address {
    text-align: left;
}

.date-section {
    padding-left: 20px;
    text-align: right;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    color: #000 !important;
}

.field-label {
    font-weight: bold;
    font-size: 15px;
}

.field-row {
    margin: 8px 0;
    font-size: 14px;
}

.field-value {
    font-size: 14px;
}

/* Content Section */
.content-section {
    padding: 20px 0;
    text-align: left;
}

.subject-line {
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 15px;
    color: #000 !important;
}

.greeting {
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 15px;
}

.letter-body {
    font-size: 14px;
    line-height: 1.8;
    text-align: justify;
    color: #000 !important;
}

.letter-body p {
    margin: 12px 0;
    text-indent: 40px;
    color: #000 !important;
}

.details-heading {
    font-weight: bold;
    margin-top: 20px !important;
    color: #000 !important;
}

/* Table Section */
.table-wrapper {
    margin: 20px 0;
    overflow-x: auto;
    color: #000 !important;
}

.details-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    color: #000 !important;
}

.details-table th,
.details-table td {
    border: 1px solid #333;
    padding: 10px;
    text-align: center;
    color: #000 !important;
}

.details-table th {
    background-color: #f0f0f0;
    font-weight: bold;
    font-size: 14px;
    color: #000 !important;
}

.details-table tbody tr:hover {
    background-color: #f9f9f9;
    color: #000 !important;
}

.total-row {
    font-weight: bold;
    background-color: #f5f5f5;
    color: #000 !important;
}

.closing-text {
    margin: 20px 0;
    font-size: 14px;
    text-indent: 40px;
}

.signature-section {
    text-align: right;
    margin: 40px 0 60px 0;
    font-size: 14px;
}

.signature-section p {
    margin: 5px 0;
}

/* Instead of display: grid */
.footer-section {
    display: block;
    padding-top: 15px;
    border-top: 2px solid #000;
    overflow: hidden; /* clearfix */
}

.footer-note {
    float: left;
    width: 48%;
    font-weight: bold;
    font-size: 15px;
    text-align: left;
}

.footer-signature {
    float: right;
    width: 48%;
    font-weight: bold;
    font-size: 15px;
    text-align: right;
}
          </style>
        </head>
        <body>
          <div id="print-section">
            ${printContent}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

  
}